<template>
  <div class="container">
    <p>Maintenance Message</p>
    <p>Status: {{system.maintenance ? 'On' : 'Off'}}</p>
    <div class="row">
        <textarea
          v-if="system.header"
          class="col-12"
          type="text"
          :rows="system.header.length / 25"
          v-model="system.header"></textarea>
    </div>
    <div class="row" >
          <textarea
            v-if="system.message"
            class="col-12"
          type="text"
          :rows="system.message.length / 25"
          v-model="system.message"></textarea>
    </div>
    <div class="row" >
        <textarea
          v-if="system.message2"
          class="col-12"
        type="text"
        :rows="system.message2.length / 30"
        v-model="system.message2"></textarea>
    </div>
    <div class="row">
      <button class="col-6-sm bigbutton" @click="toggleMaintenance()" v-if="system.maintenance">Turn Off</button>
      <button class="col-6-sm bigbutton" @click="toggleMaintenance()" v-else>Turn On</button>

      <button class="col-6-sm bigbutton" @click="saveSettings()">Save</button>
    </div>
  </div>
</template>

<script>
import {systemRef} from '../../firebase/firebaseConfig'
import Mixin from '../mixins/HelperFunctions.js'
export default {
  mixins: [Mixin],
  name: 'Settings',
  props: {},
  created() {},
  data: function (){
    return {
      // header: 'Oops',
      // message: 'We are performing a scheduled maintenance',
      // message2: 'Please check back soon!'
    }
  },
  computed: {
    system() {
      return this.$store.getters.getSystem
    }
  },
  methods: {
    saveSettings: function () {
      systemRef.doc('visitor').update(
        {
          header: this.system.header,
          message: this.system.message,
          message2: this.system.message2
        }
      ).then(function() {
      }).catch(function(error) {
        console.log('error', error)
      })
    },
    toggleMaintenance: function () {
      systemRef.doc('visitor').update(
        {
          maintenance: !this.system.maintenance
        }
      ).then(function() {
      }).catch(function(error) {
        console.log('error', error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.bigbutton {
  margin: 10px auto;
  border-radius: 5px;
  display: block;
  padding: 20px;
  background: #e9c46a;
  color: #264653;
  font-weight: bold;
  box-shadow: 0 8px 6px -6px black;
  &.add {
    background: white;
    color: green;
  }
  &.cancel {
    color: red;
    background: white;
  }
}


</style>
